<template>
  <span class="flex">
    <UtilTag
      v-for="tag in compStatusTags"
      :key="tag.label"
      :data-tooltip="tag.moreInfo"
      class="tooltip cursor-help"
      :class="[block ? 'block' : 'inline-block', tag.class]"
    >
      <FontAwesomeIcon v-if="tag.icon" :icon="tag.icon" class="mr-1" />
      <span>{{ tag.label }}</span>
    </UtilTag>
  </span>
</template>

<script>
import { faGavel } from '@fortawesome/pro-solid-svg-icons'
import UtilTag from '@/components/utils/UtilTag'

export default {
  name: 'UtilListingStatusTag',
  components: {
    UtilTag
  },
  props: {
    listing: {
      type: Object,
      required: true
    },
    showPremium: {
      type: Boolean,
      default: true
    },
    showStatus: {
      type: Boolean,
      default: false
    },
    showNew: {
      type: Boolean,
      default: false
    },
    showVetCheck: {
      type: Boolean,
      default: false
    },
    block: Boolean
  },
  computed: {
    listingIs() {
      return this.$store.getters['listing/listingIs'](this.listing)
    },

    compStatusTags() {
      let tags = []

      if (this.listingIs.auction) {
        tags.push({
          label: 'Auction',
          class: 'border  auction-tag',
          icon: faGavel,
          moreInfo: 'Live Auction'
        })
      }

      if (!this.listingIs.approved && this.showStatus) {
        tags.push({
          label: 'Held for moderation',
          class: 'bg-warning-lighter border border-warning',
          moreInfo: 'Your listing must be manually moderated before going live'
        })
      }

      if (this.listingIs.draft) {
        tags.push({
          label: 'Draft',
          class: 'bg-information-lighter border border-information-darker',
          moreInfo: 'This listing is not visible to other users until you make it live'
        })
      }

      if (this.listingIs.wanted && !this.listingIs.dead) {
        tags.push({
          label: 'Wanted',
          class: 'text-white bg-primary-button-darker',
          moreInfo: 'Wanted listing'
        })
      }

      if (this.listingIs.forSale && !this.listingIs.draft && !this.listingIs.dead) {
        if (this.listingIs.event) {
          tags.push({
            label: 'Auction',
            class: 'bg-gray-darker border border-black text-white',
            icon: faGavel,
            moreInfo: 'Live Auction'
          })
        } else if (this.listingIs.buyNowPendingSale) {
          tags.push({
            label: 'Reserved',
            class: 'bg-blue-800 border border-blue-900 text-white',
            moreInfo: 'Listing reserved by buyer'
          })
        } else if (this.listingIs.buyNow) {
          tags.push({
            label: 'Buy Now',
            class: 'text-white bg-primary-button-darker',
            moreInfo: 'For Sale Buy Now listing'
          })
        } else {
          // LIVE
          if (this.listingIs.auction) {
            tags.push({
              label: 'Live',
              class: 'bg-success border border-green-600 text-white',
              moreInfo: 'Live auction'
            })
          } else {
            tags.push({
              label: 'For Sale',
              class: 'bg-success border border-green-600 text-white',
              moreInfo: 'For Sale listing'
            })
          }
        }
      }

      if (this.listingIs.dead && !this.listingIs.sold && this.showStatus) {
        tags.push({
          label: 'Finished',
          class: 'bg-information-lighter border border-information-darker text-primary',
          moreInfo: 'This listing has finished and cannot be edited'
        })
      }

      if (this.listingIs.withdrawn) {
        tags.push({
          label: 'Withdrawn',
          class: 'bg-information-lighter border border-information-darker text-primary',
          moreInfo: 'This listing has been withdrawn and cannot be edited'
        })
      }

      if (this.listingIs.finished) {
        tags.push({
          label: this.listingIs.auction ? 'Closed' : 'Expired',
          class: 'bg-information-lighter border border-information-darker text-primary',
          moreInfo: 'This listing has finished and cannot be edited'
        })
      }

      if (this.listingIs.live && this.listingIs.approved && this.showStatus && !this.listingIs.auction) {
        tags.push({
          label: 'Live',
          class: 'bg-success-lighter border border-success',
          moreInfo: 'This listing is visible to all users'
        })
      }

      if (this.listingIs.sold) {
        tags.push({
          label: 'Sold',
          class: 'bg-danger border border-red-600 text-white',
          moreInfo: 'This listing has sold'
        })
      }

      if (this.listingIs.premium && this.showPremium) {
        tags.push({
          label: 'Premium',
          class: 'bg-blue-800 border border-blue-900 text-white',
          moreInfo: 'This is a premium listing'
        })
      }

      if (this.showNew) {
        if (this.listingIs.new) {
          tags.push({
            label: 'New',
            class: 'bg-blue-600 border border-blue-700 text-white',
            moreInfo: 'New listing'
          })
        }
      }

      if (this.showVetCheck && this.listingIs.vetChecked) {
        tags.push({
          label: 'VetChecked',
          class: 'bg-green-600 border border-green-700 text-white',
          moreInfo: 'Independently VetChecked'
        })
      }

      // Remove for now as we don't want to show matchmaking tags on search pages / this is not working correctly atm with account listing list view
      // if (this.listingIs.matchmaking) {
      //   tags.push({
      //     label: 'Matchmaking',
      //     class: 'bg-blue-800 border border-blue-900 text-white',
      //     moreInfo: 'Matchmaking'
      //   })
      // }

      return tags
    }
  }
}
</script>

<style lang="scss" scoped>
.tag.auction-tag {
  @apply font-medium;
  background: #ffd748;
  border: 1px solid #ddad04;
  color: #000;
}
</style>
